"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var NavbarHolder = _styledComponents["default"].div.attrs(function () {
  return {
    id: "navbarSupportedContent"
  };
}).withConfig({
  displayName: "NavigationLinks__NavbarHolder",
  componentId: "sc-1px3j90-0"
})(["@media (max-width:767px){height:", ";margin-left:-1rem;margin-right:-1rem;overflow:scroll;background-color:", ";margin-top:0.375rem;}@media (min-width:768px){margin-top:-1rem;margin-bottom:-1rem;height:3.75rem;}"], function (props) {
  return props.isProd ? "calc(100vh - 60px)" : "calc(100vh - ".concat(props.headerHeight, "px)");
}, function (props) {
  return props.color;
});

var Navbar = _styledComponents["default"].ul.attrs(function () {
  return {
    className: "navbar-nav flex-column mr-auto"
  };
}).withConfig({
  displayName: "NavigationLinks__Navbar",
  componentId: "sc-1px3j90-1"
})(["@media (min-width:768px){margin-top:6.75rem;}@media (max-width:767px){margin-top:2rem;}"]);

var Wrapper = _styledComponents["default"].div.withConfig({
  displayName: "NavigationLinks__Wrapper",
  componentId: "sc-1px3j90-2"
})(["@media (min-width:768px){width:4.25rem;}@media (max-width:767px){width:100vw;}"]);

var NavigationLinks = function NavigationLinks(_ref) {
  var isProd = _ref.isProd,
      open = _ref.open,
      color = _ref.color,
      children = _ref.children,
      headerHeight = _ref.headerHeight;
  var collapseClass = open ? "show" : "hide";
  return _react["default"].createElement(Wrapper, null, _react["default"].createElement(NavbarHolder, {
    isProd: isProd,
    className: "collapse navbar-collapse ".concat(collapseClass),
    color: color,
    headerHeight: headerHeight
  }, _react["default"].createElement(Navbar, null, children)));
};

NavigationLinks.propTypes = {
  isProd: _propTypes["default"].bool,
  open: _propTypes["default"].bool,
  color: _propTypes["default"].string,
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  headerHeight: _propTypes["default"].number
};
NavigationLinks.defaultProps = {
  isProd: false,
  open: false,
  color: "#041e42",
  children: {},
  headerHeight: 78
};
var _default = NavigationLinks;
exports["default"] = _default;